import React, { useState, useEffect } from "react";
import cn from "classnames";

import styles from "./Dropdown.module.sass";
import remove_accents from "remove-accents";
import { useDispatch, useSelector } from "react-redux";
import {
  pickerObjednavkyData,
  pickerObjednavky,
} from "./redux/PickerObjednavkySlice";
import axios from "axios";
import { objednavkyUrl } from "../../../features/urlHelper";
import { loginData } from "../../SignIn/redux/loginSlice";
import ClickAwayListener from "@mui/base/ClickAwayListener";

const Dropdown = ({ className, classDropdownHead, options, small, upBody }) => {
  const pickerObjednavkydata = useSelector(pickerObjednavkyData);
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  //const logindata = useSelector(loginData)

  useEffect(() => {
    dispatch(pickerObjednavky({ data: "Všechno" }));
  }, []);

  return (
    // <ClickAwayListener
    //   onClickAway={() => {
    //     setVisible(false)
    //   }}
    // >
    <div
      className={cn(
        styles.dropdown,
        className,
        { [styles.small]: small },
        {
          [styles.active]: visible,
        }
      )}
    >
      <div
        className={cn(styles.head, classDropdownHead)}
        onClick={() => {
          setVisible(!visible);
        }}
        title={window.innerWidth > 1058 ? "" : pickerObjednavkydata}
      >
        {window.innerWidth > 1058
          ? pickerObjednavkydata
          : pickerObjednavkydata.slice(0, 9)}
      </div>
      <div className={cn(styles.body, { [styles.bodyUp]: upBody })}>
        {options.map((x, index) => {
          return (
            <div
              className={cn(styles.option, {
                [styles.selectioned]: x === pickerObjednavkydata,
              })}
              onClick={() => {
                setVisible(false);
                dispatch(pickerObjednavky({ data: x }));
              }}
              key={index}
            >
              {x}
            </div>
          );
        })}
      </div>
    </div>
    // </ClickAwayListener>
  );
};

export default Dropdown;
